var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-answer chat-bubble",class:{
    'from-customer': _vm.message.DIRECTION === 'customer2club',
    'from-club': _vm.message.DIRECTION === 'club2customer',
  }},[_c('MessageDate',{attrs:{"timestamp":_vm.message.TIMESTAMP}}),_vm._v(" "+_vm._s(_vm.message.DATA_TEXT)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }